/**
 * Die Antwort des Tages — welche tiefen Antworten zu HEUTE gehören.
 * (06.09.2026, Martin: „toll wäre, wenn die tiefe Antwort auch zu Hause als
 * Information abrufbar wäre … wenn ich auf das Häkchen klicke, sodass ich
 * mich über den Tag noch an das erinnere.")
 *
 * Reine Auswahl, ohne DOM — damit sie sich prüfen lässt. Der Server liefert
 * Fäden (Wurzel + Schritte); hier zählt nur: beantwortet, und zwar heute.
 */
export interface TiefeZeile {
  id: string;
  question: string;
  answerText: string | null;
  answeredAt: string | null;
  depth: number;
}

export interface TiefeFaden {
  root: TiefeZeile;
  steps: TiefeZeile[];
}

/**
 * ⚠️ Zeitstempel aus der Datenbank sind naives UTC („2026-09-06 06:41:12").
 * Ohne das „Z" läse der Browser sie als Ortszeit — um zwei Stunden daneben,
 * und eine Antwort um 23:30 Wiener Zeit wäre „morgen".
 */
export function wienTagVon(ts: string): string {
  const iso = /[zZ]|[+-]\d\d:\d\d$/.test(ts) ? ts : ts.replace(" ", "T") + "Z";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-CA", { timeZone: "Europe/Vienna" });
}

/** Alle heute beantworteten Schritte, in der Reihenfolge des Gangs. */
export function antwortenDesTages(faeden: TiefeFaden[], heute: string): TiefeZeile[] {
  const heraus: TiefeZeile[] = [];
  const gesehen = new Set<string>();
  for (const f of faeden) {
    for (const z of [f.root, ...f.steps]) {
      if (!z.answerText?.trim() || !z.answeredAt) continue;
      if (wienTagVon(z.answeredAt) !== heute) continue;
      // Zwillinge (dieselbe Frage, dieselbe Antwort — Altlast der doppelten
      // Folgefrage vom 30.08.) nur einmal zeigen.
      const schluessel = `${z.question.trim()}\u0000${z.answerText.trim()}`;
      if (gesehen.has(schluessel)) continue;
      gesehen.add(schluessel);
      heraus.push(z);
    }
  }
  heraus.sort((a, b) => (a.answeredAt ?? "").localeCompare(b.answeredAt ?? ""));
  return heraus;
}
